import React from 'react';
import styled from '@emotion/styled';
import withTranslation from '../../../../hoc/withTranslation';
import EVSpecificationItem from './EVSpecificationItem';
import EVMaxDistanceDisplay from './EVMaxDistanceDisplay';
import { colors, fontSize } from '../../../../global/variables';
import {
  RangeIcon,
  CalendarIcon,
  WeightIcon,
  WeightHeavyIcon,
  WidthIcon,
  HeightIcon,
  VanIcon,
} from '../../../../icons/EVIcons';

const { secondaryTextColor, primaryBorderColor } = colors;

const StyledSpecsContainer = styled.details`
  background: #ffffff;
  padding: 0.75rem;
  border-radius: 0.12rem;
  border: 1px solid ${primaryBorderColor};
  margin-top: 0.75rem;
`;

const StyledSpecsTitle = styled.summary`
  font-weight: 500;
  color: ${secondaryTextColor};
  font-size: ${fontSize.medium};
  cursor: pointer;
  user-select: none;
  list-style: none;

  &::-webkit-details-marker {
    display: none;
  }

  &::before {
    content: '▼ ';
    display: inline-block;
    margin-right: 0.5rem;
    transition: transform 0.2s;
  }
`;

const StyledSpecsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
  margin-top: 0.75rem;
  font-size: ${fontSize.medium};
  color: ${secondaryTextColor};
`;

const EVSpecifications = ({
  variantData,
  translations: {
    wizard: {
      fleet: {
        evSpecsTitle,
        evRange,
        evReleaseYear,
        evUnladenWeight,
        evGrossWeight,
        evWidth,
        evHeight,
        evBodyType,
        evLengthClass,
        evHeightClass,
        evWeightClass,
      },
    },
  },
}) => {
  if (!variantData) return null;

  return (
    <StyledSpecsContainer>
      <StyledSpecsTitle>{evSpecsTitle}</StyledSpecsTitle>
      <StyledSpecsGrid>
        <EVSpecificationItem
          icon={RangeIcon}
          label={evRange.toUpperCase()}
          value={variantData.range}
          unit="km"
        />
        <EVSpecificationItem
          icon={CalendarIcon}
          label={evReleaseYear.toUpperCase()}
          value={variantData.releaseYear}
        />
        <EVSpecificationItem
          icon={WeightIcon}
          label={evUnladenWeight.toUpperCase()}
          value={variantData.unladenWeight}
          unit="kg"
        />
        <EVSpecificationItem
          icon={WeightHeavyIcon}
          label={evGrossWeight.toUpperCase()}
          value={variantData.grossWeight}
          unit="kg"
        />
        <EVSpecificationItem
          icon={WidthIcon}
          label={evWidth.toUpperCase()}
          value={variantData.width}
          unit="mm"
        />
        <EVSpecificationItem
          icon={HeightIcon}
          label={evHeight.toUpperCase()}
          value={variantData.height}
          unit="mm"
        />
        <EVSpecificationItem
          icon={VanIcon}
          label={evBodyType.toUpperCase()}
          value={variantData.bodyType?.replace(/_/g, ' ')}
        />
        <EVSpecificationItem
          icon={WidthIcon}
          label={evLengthClass.toUpperCase()}
          value={
            variantData.lengthClasses?.length > 0
              ? variantData.lengthClasses.map((lc) => lc.class).join(', ')
              : null
          }
        />
        <EVSpecificationItem
          icon={HeightIcon}
          label={evHeightClass.toUpperCase()}
          value={
            variantData.heightClasses?.length > 0
              ? variantData.heightClasses.map((hc) => hc.class).join(', ')
              : null
          }
        />
        <EVSpecificationItem
          icon={WeightIcon}
          label={evWeightClass.toUpperCase()}
          value={
            variantData.weightClasses?.length > 0
              ? variantData.weightClasses.map((wc) => wc.class).join(', ')
              : null
          }
        />
      </StyledSpecsGrid>

      <EVMaxDistanceDisplay range={variantData.range} />
    </StyledSpecsContainer>
  );
};

export default withTranslation(EVSpecifications);
